import { NgModule } from '@angular/core';
import { CollapseDirective } from './collapse.directive';
var CollapseModule = (function () {
    function CollapseModule() {
    }
    CollapseModule.forRoot = function () {
        return { ngModule: CollapseModule, providers: [] };
    };
    CollapseModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [CollapseDirective],
                    exports: [CollapseDirective]
                },] },
    ];
    /** @nocollapse */
    CollapseModule.ctorParameters = function () { return []; };
    return CollapseModule;
}());
export { CollapseModule };
//# sourceMappingURL=collapse.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/collapse/collapse.module.js
// module id = 439
// module chunks = 3